module.exports = __webpack_public_path__ + "img/people-icon.92fc2e2b.png";